import type { FaireProductEntity } from "../../entity_types/product";

export const p_whpjhamvz9: FaireProductEntity = {
  token: "p_whpjhamvz9",
  type: "product",
  name: "ViA HEAT | Tea Strainer",
  brandToken: "b_6jphlq246l",
  brandName: "VitaJuwel USA",
  imageUrl:
    "https://cdn.faire.com/fastly/57869ce65f41fcc4eb28f5df26cbd755f6cca417a97548e487fcbdaae5b5066c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/583a16d83f9d8d469290097f41b1254895a9eee5d83dd9dada1a14117e2aedca.jpeg",
    "https://cdn.faire.com/fastly/e2c0fce5e5a7b9ab60b1dd6e5233a4b4ac48e7b894838a9626ca7ae8d0cedea4.jpeg",
    "https://cdn.faire.com/fastly/1099770638bc05007758730c4cecfbabe22793d5dedf964624054a9472dd9af6.jpeg",
  ],
  priceDollars: 11.09,
  description:
    "PREMIUM QUALITY. The fine-mesh tea strainer is made from food grade, stainless steel. It comes with a highly useful stainless steel travel box to store the strainer after you use it.\n\nVERSATILE. Use it for green, black, white, matcha tea leaves as well as herbs and fruit infused water.\n\nEASY TO CLEAN. It’s diswasher safe.\n\nFOR THE FULL TEA AROMA. The XL strainer provides the perfect size for the leaves of your favorite tea to unfold their full flavor.",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:59.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
